import React from "react";
import HomeHero from "../Components/HomeHero";
import bgImg from "../Assets/Images/house-409451_1280.jpg"
import bgImg2 from "../Assets/Images/property-7046997_1280.jpg";
import bgImg3 from "../Assets/Images/property2.jpg"
import Mission from "../Components/Mision"
import Hero from "../Components/Heroo";
import PropertyCard from "../Components/PropertyCard";

const Home = () => {
  return (
    <div className="min-h-screen flex flex-col bg-gradient-to-b from-blue-50 to-white">
      {/* Hero Section */}
      <HomeHero />

      {/* Main Content Section */}
      <section className="p-4 md:p-16 bg-gray-50">
        <div className="flex flex-col lg:flex-row justify-center gap-16 items-center">
          {/* Text Content */}
          <article className="max-w-lg text-center justify-start flex flex-col space-y-6">
            <h3 className="text-3xl text-left font-light text-primary">
              We are more than developers — we are visionaries shaping the
              future.
            </h3>
            <h1 className="text-5xl text-left md:text-5xl font-bold text-primary">
              Pathway to great property innovation
            </h1>
            <p className="text-sm text-left text-gray-700 leading-relaxed">
              We work together with a shared vision to establish a real estate
              environment based on integrity, accountability, and ethical
              practices. Corruption and lack of discipline undermine the
              progress and stability of the market, eroding the trust that is
              essential for successful transactions and long-term relationships.
              Our focus is to promote a culture where professional standards and
              ethical conduct are the norm in every aspect of the real estate
              sector.
            </p>
            <button className="mt-8 px-8 py-3 w-44 bg-primary text-white text-xs rounded-md shadow-md hover:bg-secondary hover:shadow-lg transition-all duration-300">
              Learn More
            </button>
          </article>

          {/* Image Gallery */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-0">
            {/* Left Image */}
            <img
              src={bgImg2}
              alt="Property"
              className="w-full h-32 md:h-48 lg:h-64 object-cover rounded-lg shadow-md transform hover:scale-105 hover:shadow-lg transition-all duration-300"
            />

            {/* Center Image (Larger) */}
            <img
              src={bgImg}
              alt="House"
              className="w-full h-52 md:h-72 lg:h-80 object-cover rounded-lg shadow-xl transform hover:scale-110 hover:shadow-2xl transition-all duration-300 z-10"
            />

            {/* Right Image */}
            <img
              src={bgImg3}
              alt="Another Property"
              className="w-full h-32 md:h-48 lg:h-64 object-cover rounded-lg shadow-md transform hover:scale-105 hover:shadow-lg transition-all duration-300"
            />
          </div>
        </div>
      </section>
      <Hero />
      <PropertyCard />
      <Mission />
    </div>
  );
};

export default Home;
